const curEnv = process.env.CODE_ENV || 'dev'
const envInfo = require('./' + curEnv).default
export default envInfo
